import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomePolicy } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GetPolicyParams extends DefaultHttpHeaders {
  /** Numerical reference that MAPFRE assigns to each insurance contract to identify it */
  policyId: string;
  /** Identifier of the company who owns the final contract */
  companyId?: string;
  /** Version or iteration of the insurance policy */
  policyVersion?: string;
}

@Injectable()
export class GetPolicyService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Get insurance policy
   * Query insurance policy
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Policy/getPolicy
   */
  getPolicy(params: GetPolicyParams): Observable<HomePolicy> {
    const pathParams = {
      policyId: params.policyId,
    };
    const queryParams = {
      companyId: params.companyId,
      policyVersion: params.policyVersion,
    };
    

    return this.get<HomePolicy>({
      suffix: `/home/policy/${pathParams.policyId}`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
